import { render } from "./AccountPrep.vue?vue&type=template&id=fb80b590"
import script from "./AccountPrep.vue?vue&type=script&lang=js"
export * from "./AccountPrep.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Adrian\\OneDrive\\Documents\\Appsanely Ltd\\thankU\\_thankuapp\\thanku\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__